module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#pen",
      toString: function () {
        return this.url;
      }
    }